<div class="container-fluid">
	<div class="row justify-content-center">
		<div class="col-sm-8 text-center">
			<i class="fas fa-exclamation-triangle fa-5x color-warning mb-2"></i>
			<h4 class="color-info mb-4">{{ item.service.toUpperCase() }} Submission Error</h4>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<ul class="error-list">
				<li>{{ item.transactionResultStatusMessage }}</li>
			</ul>
		</div>
	</div>

	<div class="row justify-content-end pb-2">
		<div class="col-3">
			<p-button
				(click)="close()"
				label="Close"
				styleClass="p-button-text">
			</p-button>
		</div>
	</div>
</div>
